import { AddWithdrawalModal } from './AddWithdrawalModal';

export default AddWithdrawalModal;
